<template>
  <v-card>
    <v-card-title>{{ $t('reports.finances.label') }}</v-card-title>
    <v-card-text>
      <v-simple-table dense>
        <tbody>
          <tr v-if="showParts">
            <th></th>
            <th
              v-for="part in parts"
              :key="part.id"
            >
              {{ part.name }}
            </th>
          </tr>
          <tr>
            <td> {{ $t('reports.finances.contractPrice') }} </td>
            <template v-if="showParts">
              <td
                v-for="part in parts"
                :key="part.id"
                class="nowrap"
              >
                {{ part.signedPriceCents | formatCurrency(part.currency) }}
              </td>
            </template>
            <th v-else>
              <PricesDisplay
                :prices="report.signedContractPriceCents"
                :contract-currencies="currencies"
                :chosen-currency="chosenCurrency"
                :item-currency="chosenCurrency"
              />
            </th>
          </tr>
          <tr>
            <td> {{ $t('reports.finances.adaptedPrice') }} </td>
            <template v-if="showParts">
              <td
                v-for="part in parts"
                :key="part.id"
                class="nowrap"
              >
                {{ part.signedPriceCents + part.adjustmentOfPriceCents | formatCurrency(part.currency) }}
              </td>
            </template>
            <th v-else>
              <PricesDisplay
                :prices="adaptedPriceCents"
                :contract-currencies="currencies"
                :chosen-currency="chosenCurrency"
                :item-currency="chosenCurrency"
              />
            </th>
          </tr>
          <tr>
            <td> {{ $t('reports.finances.adjustments') }} </td>
            <template v-if="showParts">
              <td
                v-for="part in parts"
                :key="part.id"
                class="nowrap"
              >
                {{ part.adjustmentOfPriceCents | formatCurrency(part.currency) }}
              </td>
            </template>
            <th v-else>
              <PricesDisplay
                :prices="report.adjustmentOfPriceCents"
                :contract-currencies="currencies"
                :chosen-currency="chosenCurrency"
                :percent-text="`(${adjustmentOfContractPricePercent}%)`"
                :item-currency="chosenCurrency"
              />
            </th>
          </tr>
          <tr>
            <td> {{ $t('reports.finances.further') }} </td>
            <template v-if="showParts">
              <td
                v-for="part in parts"
                :key="part.id"
                class="nowrap"
              >
                {{ part.furtherAdjustmentOdPriceCents | formatCurrency(part.currency) }}
              </td>
            </template>
            <th v-else>
              <PricesDisplay
                :prices="report.furtherAdjustmentOdPriceCents"
                :contract-currencies="currencies"
                :chosen-currency="chosenCurrency"
                :item-currency="chosenCurrency"
              />
            </th>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { DEFAULT_REPORT } from '@/helpers'

export default {
  name: 'ReportFinances',
  props: {
    report: {
      type: Object,
      default: () => ({ ...DEFAULT_REPORT })
    },
    chosenCurrency: {
      type: Object,
      default: () => ({ })
    },
    currencies: Array,
    showParts: Boolean,
    parts: Array
  },
  data () {
    return { }
  },
  computed: {
    adaptedPriceCents () {
      const keys = Object.keys(this.report.signedContractPriceCents)
      return keys.reduce((acc, key) => {
        acc[key] = this.report.signedContractPriceCents[key] + this.report.adjustmentOfPriceCents[key]
        return acc
      }, {})
    },
    adjustmentOfContractPricePercent () {
      const percentage = (this.report.adjustmentOfPriceCents.sum / this.report.signedContractPriceCents.sum) * 100
      return percentage.toFixed(2)
    }
  }
}
</script>
